import { api } from '@/api';
import { GetRefuelAirportsParams } from '@/api/apis/mission-planner';
import { AirportType } from '@/api/apis/facilities';
import { queryClient } from '@/queries';
import { airportsQuery } from '@/queries/airports';
import { missionPlannerQueries } from '@/queries/mission-planner/mission-planner.query';
import { sleep } from '@/utils/helpers';

export const checkBenchmarkStatus = async (taskId: string): Promise<string> => {
  const { benchmarkPlans } = await queryClient.fetchQuery(missionPlannerQueries.benchmarkByPlanId(taskId));

  const isBenchmarkCompleted = benchmarkPlans.status === 'COMPLETED';

  if (isBenchmarkCompleted) {
    const hasBenchmarkErrors = !!benchmarkPlans.errors.length;

    if (hasBenchmarkErrors) {
      throw new Error(`Benchmark generation error: ${benchmarkPlans.errors.join(' ')}`);
    } else {
      return taskId;
    }
  }

  await sleep(5000);
  return checkBenchmarkStatus(taskId);
};

export const getRefuelAirportsList = async (data: GetRefuelAirportsParams): Promise<AirportType[]> => {
  const refuelAirports = await api.missionPlanner.getRefuelAirports(data);
  const list = refuelAirports.airports.map((i) => `${i.maoId}`);

  if (!list.length) return [];

  const airportsList = await queryClient.ensureQueryData(airportsQuery.items(list, 'maoIds'));

  return airportsList.items;
};
